import { AnyChatSaleChannelType, ChatType } from '@anyx/common-graphql';
import {
  AnyCreatorFaIcon,
  AnyTagIcon,
  IconType,
  InstagramCircleFaIcon,
  InstagramFaIcon,
  InstagramLogoIcon,
  LazadaCircleFaIcon,
  LazadaFaIcon,
  LineCircleFaIcon,
  LineFaIcon,
  LineLogoIcon,
  LogoLazadaIcon,
  LogoShopeeIcon,
  LogoShopifyIcon,
  LogoTikTokShopIcon,
  MessengerCircleFaIcon,
  MessengerFaIcon,
  MessengerLogoIcon,
  ShopeeCircleFaIcon,
  ShopeeFaIcon,
  ShopifyFaIcon,
  TikTokFaIcon,
  WhatsappCircleFaIcon,
  WhatsappFaIcon,
  WhatsappLogoIcon,
} from '@anyx/shared-icons';

export const CrmChannel = {
  ...AnyChatSaleChannelType,
  ...ChatType,
  ANYCREATOR: 'ANYCREATOR',
  ANYTAG: 'ANYTAG',
} as const;
export type CrmChannel = (typeof CrmChannel)[keyof typeof CrmChannel];
export type CrmChannelIconType = 'fa' | 'logo' | 'circleFa';

const CRM_CHANNEL_ICON: Record<CrmChannel, Record<CrmChannelIconType, IconType | null>> = {
  [ChatType.INSTAGRAM]: {
    fa: InstagramFaIcon,
    logo: InstagramLogoIcon,
    circleFa: InstagramCircleFaIcon,
  },
  [ChatType.LINE]: {
    fa: LineFaIcon,
    logo: LineLogoIcon,
    circleFa: LineCircleFaIcon,
  },
  [ChatType.MESSENGER]: {
    fa: MessengerFaIcon,
    logo: MessengerLogoIcon,
    circleFa: MessengerCircleFaIcon,
  },
  [ChatType.WHATSAPP]: {
    fa: WhatsappFaIcon,
    logo: WhatsappLogoIcon,
    circleFa: WhatsappCircleFaIcon,
  },
  [ChatType.LAZADA]: {
    fa: LazadaFaIcon,
    logo: LogoLazadaIcon,
    circleFa: LazadaCircleFaIcon,
  },
  [ChatType.SHOPEE]: {
    fa: ShopeeFaIcon,
    logo: LogoShopeeIcon,
    circleFa: ShopeeCircleFaIcon,
  },
  [ChatType.TIKTOK_SHOP]: {
    fa: TikTokFaIcon,
    logo: LogoTikTokShopIcon,
    circleFa: null,
  },
  [CrmChannel.SHOPIFY]: {
    fa: ShopifyFaIcon,
    logo: LogoShopifyIcon,
    circleFa: null,
  },
  [CrmChannel.ANYCREATOR]: {
    fa: AnyCreatorFaIcon,
    logo: AnyCreatorFaIcon,
    circleFa: null,
  },
  [CrmChannel.ANYTAG]: {
    fa: AnyTagIcon,
    logo: AnyTagIcon,
    circleFa: null,
  },
};

export interface CrmChannelIconProps {
  channel: CrmChannel;
  type: CrmChannelIconType;
  className?: string;
}

export const CrmChannelIcon = ({ channel, type, className }: CrmChannelIconProps) => {
  const Icon = CRM_CHANNEL_ICON[channel][type];

  if (!Icon) return null;

  return <Icon className={className} />;
};
